<div class="timeline-wrapper ion-margin-vertical">
  <div class="step">
    <div class="step-item is-done">
      <p class="body-semi-bold ion-no-margin">Now</p>
      <p class="body-normal-16 ion-no-margin">
        {{ bidCount >= 5 ? 'Closed to new offers (5 received)' : 'Open to new offers (5 maximum)' }}
      </p>
    </div>
    <div class="step-item">
      <p class="body-semi-bold ion-no-margin">
        <moment-display
          [date]="job?.timestamps?.closingTime"
          [fromNow]="false"
        ></moment-display>
      </p>
      <p class="body-normal-16 ion-no-margin">Job closes if no offers are accepted</p>
    </div>
  </div>
</div>
